export default __webpack_public_path__ + "static/media/cart.d6cd6beb.png";